import { colors} from './colors'

export const Quality_Rate = {
    title: 'Quality',
    valueKey: 'quality_rate',
    oee_type: 'oee-rate',
    color: colors['Quality']
}

export const Availability_Rate = {
    title: 'Availability',
    valueKey: 'availability_rate',
    oee_type: 'oee-rate',
    color: colors['Availability']
 }

export const Performance_Rate = {
    title: 'Performance',
    valueKey: 'performance_rate',
    oee_type: 'oee-rate',
    color: colors.Performance
}

export const oee = {
    title: 'OEE',
    valueKey: 'oee',
    oee_type: 'oee-rate',
    color: colors['oee']
}


export const allOee = { 
    oee, 
    Availability_Rate, 
    Performance_Rate,
    Quality_Rate, 
}